import React from 'react'
import { string, number, bool } from 'prop-types'
import classNames from 'classnames'

const Avatar = ({
  backgroundColor,
  bordered,
  className: classNameProp,
  rounded,
  size,
  disabled,
  ...other
}) => {
  const className = classNames('campus-avatar', classNameProp, {
    'campus-avatar--rounded': rounded,
    'campus-avatar--bordered': bordered,
    disabled,
  })

  return (
    <>
      <div className={className} {...other} />
      <style jsx>
        {`
          .campus-avatar {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: ${size || 56}px;
            height: ${size || 56}px;
            overflow: hidden;
            color: #fff;
            background-color: ${backgroundColor || '#fff'};
            padding: 8px;
            border-radius: 8px;
            &.campus-avatar--rounded {
              border-radius: 100%;
              :global(img) {
                border-radius: 100%;
              }
            }
            &.campus-avatar--bordered {
              border: solid 1px #bed2e8;
            }
            :global(img) {
              max-width: 100%;
              max-height: 100%;
              border-radius: 8px;
            }
            @media screen and (min-width: 768px) {
              padding: 16px;
            }
            &.disabled {
              filter: grayscale(.8);
            }
          }
        `}
      </style>
    </>
  )
}

Avatar.propTypes = {
  className: string,
  bordered: bool,
  image: string,
  icon: string,
  rounded: bool,
  size: number,
  disabled: bool,
}

export default Avatar
